import styled, { css } from 'styled-components';
import { colorSchemePreserveAttrs } from 'src/utils/colorScheme';
import { BackgroundColors, IconSize } from './index';

export const Badge = styled.div.attrs<{ $src?: string }>(({ $src }) =>
  $src ? colorSchemePreserveAttrs : {},
)<{
  $src?: string;
  $background: BackgroundColors;
  $size: IconSize;
}>(
  ({ theme, $src, $background, $size }) => css`
    border-radius: ${theme.bo.round};
    background-color: ${theme.co[$background]};
    background-image: url('${$src}');
    width: ${theme.sz[$size]};
    height: ${theme.sz[$size]};
    background-position: center;
    background-size: 50%;
    background-repeat: no-repeat;
    /* 0.5 to match background-size: 50% when an icon from our library is used */
    font-size: calc(${theme.sz[$size]} * 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  `,
);

export const IconWrapper = styled.div(
  ({ theme }) => css`
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: ${theme.sz.s5};
  `,
);
